import React, { FC } from 'react';

export const PriceModal: FC<{
  isOpen: boolean;
  onClose: () => void;
}> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div
      className='modal fade show'
      style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
      tabIndex={-1}
      aria-labelledby='contact-price-modalLabel'
      aria-hidden={!isOpen}
      onClick={onClose}
    >
      <div
        className='modal-dialog modal-dialog-centered'
        onClick={(e) => e.stopPropagation()}
      >
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title'>お問い合わせを承りました</h5>
            <button
              className='btn-close'
              type='button'
              onClick={onClose}
              aria-label='Close'
            />
          </div>
          <div className='modal-body'>
            <p>
              レク料金のお問い合わせを承りました。
              <br />
              料金が確認でき次第、ご登録いただいておりますご担当者様宛に運営事務局からご連絡差し上げますので、今しばらくお待ちください。
            </p>
          </div>
          <div className='modal-footer'>
            <button
              className='btn btn-cprimary rounded-pill text-white'
              type='button'
              onClick={onClose}
            >
              閉じる
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
